import { HTTP, authHeader, HTTP_RETROFIT } from './http-service';

class LicenceNumberService {
  getById(trustmarkBusinessId) {
    return HTTP.get(`/trustmarkbusiness/${trustmarkBusinessId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getByTMLN(tmln) {
    return HTTP.get(`/trustmarkbusiness/tmln/${tmln}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  search(payload) {
    return HTTP.post(`/trustmarkbusinesssearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/trustmarkbusinesssearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  makePrimary(payload) {
    return HTTP.put(
      `/trustmarkbusiness/makeprimary/${payload.trustmarkBusinessId}/${payload.schemeBusinessId}`,
      {},
      {
        headers: authHeader(),
      }
    ).then((response) => {
      return response.data;
    });
  }

  makeInactive(payload) {
    return HTTP.put(
      `/trustmarkbusiness/makeinactive/${payload.trustmarkBusinessId}/${payload.schemeBusinessId}`,
      {},
      {
        headers: authHeader(),
      }
    ).then((response) => {
      return response.data;
    });
  }

  createAssociation(payload) {
    return HTTP.post(`/TrustmarkBusinessGroup/${payload.trustmarkBusinessId}`, payload.trustmarkBusinessGroup, {
      headers: authHeader()
    }).then((response) => {
      return response.data;
    });
  }

  getAllAssociationsByTrustmarkBusinessId(payload) {
    return HTTP.get(`/TrustmarkBusinessGroupAssociation/${payload.trustmarkBusinessId}`, {
      headers: authHeader()
    }).then((response) => {
      return response.data;
    });
  }

  joinAssociation(payload) {
    return HTTP.post(`/TrustmarkBusinessGroupAssociation/joinassociation`, payload, {
      headers: authHeader()
    }).then((response) => {
      return response.data;
    });
  }

  removeAssociation(payload) {
    return HTTP.put(`/TrustmarkBusinessGroupAssociation/removeassociation`, payload, {
      headers: authHeader()
    }).then((response) => {
      return response.data;
    });
  }

  updateGroup(payload) {
    return HTTP.put(`/TrustmarkBusinessGroup/updategroup`, payload, {
      headers: authHeader()
    }).then((response) => {
      return response.data;
    });
  }

  deleteGroup(payload) {
    return HTTP.delete(`/TrustmarkBusinessGroup/${payload.trustmarkBusinessGroupId}`, {
      headers: authHeader()
    }).then((response) => {
      return response.data;
    });
  }

  groupSearch(payload) {
    return HTTP.post(`/trustmarkbusinessgroupsearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  groupSearchAdvanced(payload) {
    return HTTP.post(`/trustmarkbusinessgroupsearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getRemediationDateHistoryByTmln(payload) {
    return HTTP_RETROFIT.get(`/RemediationDateHistory/${payload.tmln}`, {
      headers: authHeader()
    }).then((response) => {
      return response.data;
    });
  }

  requestRemediationDateHistoryMeasureExport(remediationDateHistoryId) {
    return HTTP_RETROFIT.post(`/Export/remediation-date-history/${remediationDateHistoryId}`, {}, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  downloadRemediationDateHistoryMeasureExport(exportRequestId) {
    return HTTP_RETROFIT.get(`/Export/Download/csv/${exportRequestId}`, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      }
    );
  }
}

export default new LicenceNumberService();
